import { render, staticRenderFns } from "./labelCostStat.vue?vue&type=template&id=02bdaf68&scoped=true&"
import script from "./labelCostStat.vue?vue&type=script&lang=js&"
export * from "./labelCostStat.vue?vue&type=script&lang=js&"
import style0 from "./labelCostStat.vue?vue&type=style&index=0&id=02bdaf68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bdaf68",
  null
  
)

component.options.__file = "labelCostStat.vue"
export default component.exports